import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Joperator(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
 <Sides/>
 <Helmet>
 
<title>Java operator tutorial For Beginners</title>
<meta name="description" content="Java operator tutorial for beginners.Operators in Java are used special symbols which perform any type of operations." />
<meta name="keywords" content="codeexampler,programming language,tutorial for begineers,java operator,javascript operator
,what is java operator,java operators,java is operator,java operator ternary,java operator module,java operator precedence
,java and operator,java operator and,operator overloading in java,java operator overloading" />
<link rel="canonical" href="https://www.codeexampler.com/java-operators" />
</Helmet>

<div className='lg:pl-56'>


    <h1 className="m-4 mh1">Java operator</h1>
    <div className="first">
        <a href="/java-data-types">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-keywords">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">The Operator in Java:</h2>
    <p className="mt-4 para">Operators in Java are used special symbols that perform any operation.<br/>
<span className="bold">OR</span><br/>
 Java and operator is a special symbol that is used in the expression. 
</p>



<h2 className="headings">The Operator in Java Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>        

  {"\n"}
  <span className="qwerty-1">106</span>
  <span className="qwerty">/</span>
  <span className="qwerty-1">8</span>
  <span className="qwerty">%</span>
  <span className="qwerty-1">40</span>
  <span className="qwerty">+</span>
  <span className="qwerty-1">5</span>
  <span className="qwerty">-</span>
  <span className="qwerty-1">2</span>

  {"\n"}  {"\n"}
  </code>
      </pre>        
    </div>
    <div>
      <h3 className="headings">Answer</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;(+-/%) this is an operator </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>
<br/>
<h2 className="mt-4 mh2">Operator in Java Syntax Example:</h2>


    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          
      <span className="qwerty-2">int </span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">b</span>

 
  {"\n"}
  <span className="qwerty">=</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty">+</span>
  <span className="qwerty-10"> are an operator</span>
  {"\n"}
  <span className="qwerty-4">a</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty-4">b</span>
  <span className="qwerty-10"> is an operand</span>
  {"\n"}
  {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>




<h2 className="headings">Another Operator in Java Syntax code:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          
      <span className="qwerty-2">int </span>
    <span className="qwerty-4">A</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">c</span>
    <span className="qwerty">+</span>
    <span className="qwerty-4">d;</span>
    <span className="qwerty-10"> Above in this line of code  </span>
 
  {"\n"}
  <span className="qwerty">+</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty">=</span>
  <span className="qwerty-10"> are operators means there are Two operators</span>
  {"\n"}
  <span className="qwerty-4">b</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty-4">c</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty-4">d</span>
  <span className="qwerty-10"> are operands means there are Three operands</span>
  {"\n"}
  {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>



<h2 className="headings">Operator in Java Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          
    <span className="qwerty-4">A</span>
    <span className="qwerty">=</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty">*</span>
    <span className="qwerty-4">d</span>
    <span className="qwerty">-</span>
    <span className="qwerty-4">c;</span>
    {"\n"}
    <span className="qwerty-10">Above in this line of code  </span>
 
  {"\n"}
  <span className="qwerty">+</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty">=</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty">-</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty">*</span>
  <span className="qwerty-10">  are operators means there are Four operators</span>
  {"\n"}
  <span className="qwerty-4">b</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty-4">c</span>
  <span className="qwerty-1">,</span>
  <span className="qwerty-4">d</span>
  <span className="qwerty-10"> are operands means there are Three operands</span>
  {"\n"}
  {"\n"}
     </code>
      </pre>        
    </div>

<h2 className="mt-4 mh2">1, Arithmetic operator:</h2>
<h3 className="mt-4 mh3">+ add<br/>
-Sub<br/>
Multiply<br/>
/ division<br/>
% modules<br/>
++ increment<br/>
-- decrement<br/>
</h3>
<h2 className="mt-4 mh2">Java Operator Example</h2>

      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-2">&nbsp;int </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty"> ,</span>
            <span className="qwerty-4">b</span>
            <span className="qwerty"> ,</span>
            <span className="qwerty-4">c;</span>

            {"\n"}
            <span className="qwerty-4">&nbsp;a</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-1">8;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;b</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-1">4;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;c</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty">+</span>
            <span className="qwerty-4">b;</span>

            {"\n"}
            <span className="qwerty-10">&nbsp;System</span>
            <span className="qwerty">.</span>
            <span className="qwerty-10">out</span>
            <span className="qwerty">.</span>
            <span className="qwerty-10">println</span>
            <span className="qwerty-1">(</span>
            <span className="qwerty-4">"c"</span>
            <span className="qwerty-1">);</span>
            {"\n"} {"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div
          style={{
            background: "#0f0e33",
            width: "94%",
            marginLeft: "3%",
            paddingLeft: "2%",
            borderRadius: "20px",
          }}
        >
          <pre style={{ maxHeight: "500vh" }}>
            <code className="python hljs">
              {"\n"}
              <span className="qwerty-3">&nbsp;12 </span>
              {"\n"}
            </code>
            {"   "}
          </pre>
        </div>
      </div>



<h2 className="headings">Java Operator Example code</h2>
      <div
        style={{
          background: "#0f0e33",
          width: "94%",
          marginLeft: "3%",
          paddingLeft: "2%",
          borderRadius: "20px",
        }}
      >
        <pre style={{ maxHeight: "500vh" }}>
          <code>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">-</span>
            <span className="qwerty-4">b;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">*</span>
            <span className="qwerty-4">b;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">/</span>
            <span className="qwerty-4">b;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">%</span>
            <span className="qwerty-4">b;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">++;</span>
            <span className="qwerty-10"> OR </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-5">--;</span>
            {"\n"}
            <span className="qwerty-4">&nbsp;C</span>
            <span className="qwerty"> = </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-5">++;</span>
            <span className="qwerty-10"> OR </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-5">--;</span>
            {"\n"}

            {"\n"}
          </code>
        </pre>
      </div>


<h2 className="mt-4 mh2">2, Relational operator:</h2>
<h3 className="mt-4 mh3"> Greater than  <br/>
&#60;less than <br/>
&#62;=greater than or equal to<br/>
&#60;= -less than or equal to<br/>
!= - not equal to<br/>
== -equal to<br/>
</h3>

<h2 className="mt-4 mh2">Java Relational Operator Example:</h2>




    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-10">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> ,</span>
    <span className="qwerty-4">b;</span>
 
  {"\n"}
  <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">10;</span>
    {"\n"}
    <span className="qwerty-4">b</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>

  {"\n"}
  <span className="qwerty-5">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty">&#60;</span> 
        <span className="qwerty-4">b</span> 
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&#123; </span>
  {"\n"} 

  <span className="qwerty-10">&nbsp;System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"b is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  {"\n"}

  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;b is greater </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Java another Operator Example code:</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-2">&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> ,</span>
    <span className="qwerty-4">b;</span>
 
  {"\n"}
  <span className="qwerty-4">&nbsp;a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;b</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>

  {"\n"}
  <span className="qwerty-5">&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty">&#60;=</span> 
        <span className="qwerty-4">b</span> 
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&#123; </span>
  {"\n"} 

  <span className="qwerty-10">&nbsp;&nbsp;System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"both equal"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&#125; </span>

  {"\n"}

  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;both equal </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">3, Logic operator:</h2>
<h3 className="mt-4 mh3">And  &#38;&#38;<br/>
Or   &#124;&#124;<br/>
Not&#33;
</h3>



<h2 className="headings">Java Logic Operator Example code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-10">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> ,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty"> ,</span>
    <span className="qwerty-4">c;</span>
 
  {"\n"}
  <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>
    {"\n"}
    <span className="qwerty-4">b</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>

  {"\n"} 
  <span className="qwerty-4">c</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">40;</span>

  {"\n"} 

  <span className="qwerty-10">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty">&#60;=</span> 
    <span className="qwerty-4">b</span>
      <span className="qwerty-6"> && </span>
    <span className="qwerty-4">a</span>
      <span className="qwerty">&#62;</span> 
    <span className="qwerty-4">c</span>
      <span className="qwerty-1">);</span>
      {"\n"}

  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;false </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">4, Bitwise operator:</h2>
<h3 className="mt-4 mh3">
&#62;&#62; - right shift<br/>
    &#60;&#60; - left shift<br/>
^ xor<br/>
~ B Not<br/>
</h3>

<h2 className="mt-4 mh2">5, Assignment operator:</h2>
<h3 className="mt-4 mh3">=<br/>
+=<br/>
-=<br/>
*=<br/>
/=<br/>
%=<br/>
&#47;&#47;=<br/>
**=<br/>
&#38;=<br/>
&#60;&#60;=<br/>
&#62;&#62;=<br/>
^=<br/>
</h3>

<h2 className="mt-4 mh2">6, Identifier operator in Java:</h2>



    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-2">int </span>
    <span className="qwerty-4">a;</span>
 
  {"\n"}
  <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">5;</span>
    {"\n"}

  <span className="qwerty-6">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">*</span>
    <span className="qwerty-1">4;</span>
    {"\n"}

  <span className="qwerty-6">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;5 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<h2 className="mt-4 mh2">7, The conditional operator (?:) in Java-
</h2>
<p className="mt-4 para">A conditional operator is known as a ternary operator.<br/>
* The main point is that this Conditional operator consists of three operands.<br/>
</p>


<h2 className="headings">Java Operator Syntax code</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-2">&nbsp;Variable </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">(</span>
      <span className="qwerty-4">expression</span>
      <span className="qwerty-1">)</span>
      <span className="qwerty">&#63;</span>
      <span className="qwerty-2">true</span>
      <span className="qwerty">:</span>
      <span className="qwerty-2">false</span>
  {"\n"}
  
      {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>


<h2 className="mt-4 mh2">8, Unary operator:</h2>
<h3 className="mt-4 mh3">++<br/>
--
</h3>
<h2 className="mt-4 mh2">Q-Java unary Operator increment a by using (++) Example?</h2>


    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
                
      {"\n"}
      <span className="qwerty-2">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">10;</span>
 
  {"\n"}

  <span className="qwerty-4">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-4">a</span>
    <span className="qwerty">++;</span>
    {"\n"}

  <span className="qwerty-4">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;11 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


<br/>

<h2 className="headings">Q-If you add more no inside unary Java operator?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"} 
        <span className="qwerty-6">int </span>
    <span className="qwerty-2"> a </span>
    <span className="qwerty-1">;</span>
 
     
      {"\n"}
    <span className="qwerty-2">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20;</span>
 
  {"\n"}
  <span className="qwerty-2">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-2">a</span>
    <span className="qwerty"> + </span>
    <span className="qwerty-1">2;</span>
 
  {"\n"}
{"\n"}
  <span className="qwerty-10">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
  <span className="qwerty-5">&nbsp;OR</span>
  {"\n"}
    <span className="qwerty-2">a </span>
    <span className="qwerty">++++; </span>
    {"\n"}   {"\n"}
    <span className="qwerty-10">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-10">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;22 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;error </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>




<h2 className="headings">Q-Change position of the unary operator?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        {"\n"}
        <span className="qwerty-10">{`// If we use (++a)`} </span>
      {"\n"}
      <span className="qwerty-10">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">10</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b;</span>
 
  {"\n"}

  <span className="qwerty-2">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-4">b</span>
    <span className="qwerty"> = </span>
    <span className="qwerty">++</span>
    <span className="qwerty-4">a;</span>
    {"\n"}

  <span className="qwerty-2">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
  <span className="qwerty-6">OR</span>
        {"\n"}{"\n"}
        <span className="qwerty-10">{`// if we use (a++)`} </span>
      {"\n"} 
      <span className="qwerty-10">int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-1">20</span>
    <span className="qwerty">,</span>
    <span className="qwerty-4">b;</span>
 
  {"\n"}

  <span className="qwerty-2">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">a</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-4">b</span>
    <span className="qwerty"> = </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty">++;</span>
    {"\n"}

  <span className="qwerty-2">System</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">b</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  {"\n"}
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;10 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;11 </span>          
          {"\n"}
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;20 </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>

  <h1 className="mt-5">  </h1>
   
  <div className="back">
        <a href="/java-data-types">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-keywords">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
)

}
export default Joperator;